import { Box, Button, Text, Heading } from "@chakra-ui/react";

export default function DescriptionCardWP({ ImgUrl, description, title, textButton, onClick, height = "350px", isDisabled = false }) {
  return (
    <Box
      position="relative"
      height={height}
      width="100%"
      bgImage={ImgUrl}
      bgSize="cover"
      bgPosition="center"
      display="flex"
      alignItems="center"
      justifyContent="center"
      _hover={{ boxShadow: "dark-lg" }}
      borderRadius="lg"
      overflow="hidden"
      pointerEvents={isDisabled ? "none" : "auto"}
    >
      {/* Overlay */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg="rgba(0, 0, 0, 0.5)"
      />

      {/* Content */}
      <Box
        position="relative"
        color="white"
        textAlign="center"
        padding="20px"
        maxWidth="600px"
      >
        <Heading as="h2" size="xl" mb={4} fontWeight="bold" lineHeight="1.2">
          {title}
        </Heading>
        <Text fontSize="lg" mb={6}>
          {description}
        </Text>
        <Button
          colorScheme="green"
          size="lg"
          fontWeight="bold"
          onClick={isDisabled ? undefined : onClick} // Prevents button click when disabled
          isDisabled={isDisabled}>
          {textButton}
        </Button>
      </Box>
    </Box>
  );
}
